import { dateLocales } from '@/locales';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import i18n from 'i18next';

function useLocale() {
    const locale = useSelector((state) => state.theme.locale);

    useEffect(() => {
        if (locale !== i18n.language) {
            i18n.changeLanguage(locale);
        }

        document.documentElement.lang = locale;

        dateLocales[locale]?.().then(() => {
            dayjs.locale(locale);
        });
    }, [locale]);

    return locale;
}

export default useLocale;
